import { init as initTyreIndexExplanationLightbox } from '../../../_views/tyre_index_explanation_lightbox/tyre_index_explanation_lightbox_view';
import { initializeCommonPageModules } from './common_page_modules';
import { init as initCatalogConfigurator } from '../../../_views/configurator/catalog_configurator';
// import { init as initRegoLookup } from '../../../_views/rego_lookup/rego_lookup';
import { init as initInfoPopup } from '../../../_views/info_popup/info_popup_view';
import { init as initTyreFiltersColumn }
    from '../../../_views/catalog_filter_column/tyre';
import { init as initFiltersLightbox } from '../../../_views/catalog_filter_lightbox/tyre';
import CatalogContainersConstants from './catalog_container_constants';
import { init as initStatusbar } from '../../../_views/statusbar/catalog_statusbar';
import { InfoPopupContainer } from '../../../_constants/info_popup';
import { init as initProductMixedStocksApp } from '../../../_views/product_mixed_stocks/product_mixed_stocks';
import initializeTargetComponent,
{ initializeConfiguratorComponents } from '../../../_views/initialize_component';
import {
    onOpenRegoLookupClick,
    onOpenVehicleConfiguratorClick
}
    from '../../../_views/configurator_buttons/configurator_buttons';
import { noop } from '../../../../lib/utilities';
import { showFiltersAction } from '../../../_flux/actions/catalog_filter_view_actions';

function initializeTyrePageModules(productType) {
    const currencyIsoCode = TYROOLA.globals.currencyIsoCode;

    /**
     *
     * initialize initially visible components first
     *
     */
    const filtersColumnContainer = document.getElementById(CatalogContainersConstants.CATALOG_FILTERS_COLUMN_CONTAINER_ID);
    const filtersColumnOptions = { productType, currencyIsoCode };
    initTyreFiltersColumn(filtersColumnContainer, filtersColumnOptions);
    
    const isRevampContainer = document.getElementById(CatalogContainersConstants.CATALOG_ITEMS_REVAMP_CONTAINER_ID);
    if (!isRevampContainer) {
        showFiltersAction(true);
    }

    initializeCommonPageModules(productType);

    const statusbarContainer = document.getElementById(CatalogContainersConstants.STATUSBAR_CONTAINER_ID);
    const displayDimensions = TYROOLA.initialFluxStates.statusbar.displayDimensions;
    const options = { productType, displayDimensions };
    initStatusbar(statusbarContainer, options);

    /**
     *
     * initialize lightbox components afterwards
     *
     */
    const filtersLightboxContainer = document.getElementById(CatalogContainersConstants.CATALOG_FILTERS_LIGHTBOX_CONTAINER_ID);
    const filtersLightboxOptions = { productType, currencyIsoCode, displayDimensions };
    initFiltersLightbox(filtersLightboxContainer, filtersLightboxOptions);

    const catalogConfiguratorContainer = document.getElementById(CatalogContainersConstants.CONFIGURATOR_CONTAINER_ID);
    const catalogConfiguratorOptions = { productType, staticUrl: TYROOLA.globals.staticUrl };
    initCatalogConfigurator(catalogConfiguratorContainer, catalogConfiguratorOptions);

    // const vehicleConfiguratorContainer = document.getElementById(CatalogContainersConstants.VEHICLE_CONFIGURATOR_CONTAINER_ID);
    // const vehicleConfiguratorContainerOptions = { productType, staticUrl: TYROOLA.globals.staticUrl };
    // initVehicleConfigurator(vehicleConfiguratorContainer, vehicleConfiguratorContainerOptions);
    initializeConfiguratorComponents({ productType, staticUrl: TYROOLA.globals.staticUrl });
    initializeTargetComponent(
        'a[href*="#open-vehicle-configurator"]',
        noop,
        onOpenVehicleConfiguratorClick
    );

    // const regoLookupContainer = document.getElementById(CatalogContainersConstants.REGO_LOOKUP_CONFIGURATOR_CONTAINER_ID);
    // const regoLookupContainerOptions = { productType, staticUrl: TYROOLA.globals.staticUrl };
    // initRegoLookup(regoLookupContainer, regoLookupContainerOptions);

    initializeTargetComponent(
        'a[href*="#open-rego-lookup"]',
        noop,
        onOpenRegoLookupClick
    );

    const tyreIndexExplanationLightboxContainer = document.getElementById(CatalogContainersConstants.TYRE_INDEX_EXPLANATION_LIGHTBOX_CONTAINER_ID);
    initTyreIndexExplanationLightbox(tyreIndexExplanationLightboxContainer);

    initInfoPopup(document.getElementById(InfoPopupContainer), {});

    const productMixedStocksAppContainer = document.getElementById(CatalogContainersConstants.PRODUCT_MIXED_STOCKS_APP_CONTAINER_ID);
    initProductMixedStocksApp(productMixedStocksAppContainer, {});
}

export { initializeTyrePageModules };